import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';

import {ImagePreloadDirective} from '../../directives/image-preload.directive';

@Component({
  selector: 'app-link-carousel',
  templateUrl: './link-carousel.component.html',
  styleUrls: ['./link-carousel.component.scss']
})
export class LinkCarouselComponent implements OnInit, OnChanges {
  @Input() items:[];
  @Input() unlinkedItems:[];
  displayItems = [];
  displayUnlinkedItems = [];
  @Output() displayContent = new EventEmitter<any>();
  @Output() deleteItem = new EventEmitter<any>();
  showUnlinked: boolean = false;
  searchTerm: string = "";
  focus;
  
  constructor() {}

  ngOnInit() {
    this.displayItems = this.items;
    this.displayUnlinkedItems = this.unlinkedItems;
    
  }

  ngOnChanges(value) {
    this.displayItems = value.items.currentValue;
  }

  showPage(url) {
    this.displayContent.emit(url);
  }


  confirmDelete(link) {
    this.deleteItem.emit(link);
  }


  //TODO: Filter for array of search terms
  filterBookmarks() {
    this.displayItems = this.items.filter((item)=>{
      if ((<any>item).siteData) {
        return (<any>item).siteData.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
      } else {
        return false
      }
    });

    this.displayUnlinkedItems = this.unlinkedItems.filter((item)=>{  
      if ((<any>item).siteData) {
        return (<any>item).siteData.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
      } else {
        return false
      }
    })

  }

  closeSearch() {
    
  }

}
